export const audienceSetOptions = {
  MARKET: "market",
  DEVICE_LIST: "deviceList"
};
